import { getCurrency, getDateFormat, getLanguage, getTimezone } from 'helpers/locale';
import { getRegisterId } from 'helpers/session';
import { SessionData } from 'root/apps/QuoteMachineIntegration/state/SessionData';

const AUTO_AR_RIGHT = 'customers_automated_accounts_receivable';

export function getSessionData(currentSale?: Sale): SessionData {
  return {
    locale: getLanguage(),
    dateFormat: getDateFormat(),
    timezone: getTimezone(),
    currency: getCurrency(),
    registerId: getRegisterId(),
    currentSale,
    features: {
      CustomersInvoicingIntegrationIncreasemakepaymentactions: window.lsCloud.Modules.hasModule(
        'customers.invoicing_integration.increasemakepaymentactions'
      ),
      InvoicingApiV1: window.lsCloud.Modules.hasModule('invoicing.api.v1'),
    },
    permissions: {
      hasAutomatedAccountReceivablesRight: window.merchantos.session.hasRight(AUTO_AR_RIGHT),
      hasAdminRight: window.merchantos.session.hasRight('admin'),
    },
    datadog:
      typeof window.DD_RUM?.getInitConfiguration === 'function' &&
      !!window.DD_RUM?.getInitConfiguration()
        ? {
            // Only passing down the methods we need from the datadog RUM public API
            addAction: window.DD_RUM.addAction,
            addError: window.DD_RUM.addError,
          }
        : undefined,
  };
}
